import React, { useState, useEffect } from "react";
import { Button, Collapse } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { Account, SearchNode, getEntityIcon, mapEntryType, useGetPath, PathInfo, useGetPathList, DriveEntryType } from "src/common";
import { Icon, Loading } from "src/components";
import { Breadcrumbs } from ".";

type AllProps = {
    current_account: Account;
    search_node: SearchNode;
    path_info?: PathInfo[];
    handleRowAction: (id: string, path_info: PathInfo[]) => void;
    handleAction: ActionHandlerFunction;
}

// Description: Build each Search Result row
function SearchRowComponent(props: AllProps) {
    const { current_account, search_node, path_info, handleRowAction, handleAction } = props;
    const [opened, setOpened] = useState<boolean>(false);
    const [node_id, setNodeId] = useState<string>(search_node.id);
    const [_path_info, setPathInfo] = useState<PathInfo[] | undefined>(path_info);
    const entry_info = mapEntryType(search_node.type, search_node.name);
    const { getPath, full_path_list } = useGetPath(current_account); // reset: resetPathInfo 
    const { buildBreadcrumbs, breadcrumbs_paths } = useGetPathList(current_account);

    useEffect(() => {
        setPathInfo(path_info);
    }, [path_info]);

    useEffect(() => {
        if (node_id !== search_node.id) {
            opened && setOpened(false);
            setNodeId(search_node.id);
        }
    }, [search_node]);

    // Description: Fetch the item full path list if not already resolved into PathInfo
    useEffect(() => {
        (!!full_path_list && !path_info) &&
            buildBreadcrumbs(search_node.collection_id, full_path_list, undefined, search_node.type === DriveEntryType.LINK);
    }, [full_path_list]);

    // Description: Upon fully decrypted, update the main Entry in ListView
    useEffect(() => {
        !!breadcrumbs_paths && handleSuccessBreadcrumbs(breadcrumbs_paths.slice());
    }, [breadcrumbs_paths]);


    // Description: Build breadcrumbs if not there already and opened collapsable 
    function handleRowClick(node: SearchNode) {
        const new_opened = !opened;
        (!_path_info && !opened) &&
            getPath(search_node.collection_id, search_node.id);
        setOpened(new_opened);
    }

    // Description: Handle the successful return from getPathInfo and send to parent for storing
    function handleSuccessBreadcrumbs(_breadcrumbs_paths: PathInfo[]) {
        setPathInfo(_breadcrumbs_paths);
        handleRowAction(search_node.id, _breadcrumbs_paths);
    }

    return <>
        <li onClick={() => handleRowClick(search_node)}>
            <Icon className={entry_info?.type_class || getEntityIcon(search_node.type)} />
            <div>
                <p data-tooltip-id="pv-tooltip" data-tooltip-content={search_node.name}>
                    {search_node.name}
                </p>
                <div>
                    <span>{entry_info?.type_label}</span>
                    <span>{search_node.last_modification_date}</span>
                </div>
                <Button variant="icon" className="close">
                    <Icon className={opened ? "ficon-chevron-up" : "ficon-chevron-down"} />
                </Button>
            </div>
        </li>
        <Collapse in={opened}>
            <li className="info">
                <div>
                    {
                        !!_path_info ?
                            <Breadcrumbs
                                search_node={search_node}
                                path_info={_path_info}
                                handleAction={handleAction} /> :
                            <Loading message=" " className="in-place" />
                    }
                </div>
            </li>
        </Collapse>
    </>;
}
export default React.memo(SearchRowComponent);
